// extracted by mini-css-extract-plugin
module.exports = {"guide":"OrderTransactions_guide__1mRjS","intro_1":"OrderTransactions_intro_1__cKapn","intro":"OrderTransactions_intro__12cqO"};